var HttpCookie = (function () {
    function HttpCookie(name, value, path, domain, expires, maxAge, secure, httpOnly) {
        this.name = name;
        this.value = value;
        this.path = path;
        this.domain = domain;
        this.expires = expires;
        this.maxAge = maxAge;
        this.secure = secure;
        this.httpOnly = httpOnly;
    }
    return HttpCookie;
}());
export default HttpCookie;
//# sourceMappingURL=HttpCookie.js.map